import { SxProps, Theme } from '@mui/material';

export const commonStyles = {
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as SxProps<Theme>,

  flexColumnCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  } as SxProps<Theme>,

  fullHeight: {
    minHeight: '100vh',
  } as SxProps<Theme>,

  sectionTitle: {
    mb: { xs: 2, sm: 3 },
  } as SxProps<Theme>,

  card: {
    mb: 2,
  } as SxProps<Theme>,

  cardContent: {
    p: { xs: 1, sm: 2 },
  } as SxProps<Theme>,

  avatar: {
    width: { xs: 32, sm: 40 },
    height: { xs: 32, sm: 40 },
    border: '1px solid',
    borderColor: 'divider',
  } as SxProps<Theme>,

  divider: {
    my: 1,
  } as SxProps<Theme>,

  textButton: {
    textTransform: 'none',
    fontSize: { xs: '0.875rem', sm: '1rem' },
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  } as SxProps<Theme>,
}; 